import { render } from "./adminseven.vue?vue&type=template&id=7a538eb2&scoped=true"
import script from "./adminseven.vue?vue&type=script&lang=js"
export * from "./adminseven.vue?vue&type=script&lang=js"

import "./adminseven.vue?vue&type=style&index=0&id=7a538eb2&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a538eb2"]])

export default __exports__